import { emailRegex } from "@/utils/regex";
import { getNestedModalAutocompleteProps } from "@/components/auto-complete/nested-modal-popper";

interface IDocumentContactOption {
  id?: string;
  contactName?: string;
}

interface IContactFieldState {
  contactName?: string;
  contactPhone?: string;
  contactMail?: string;
  readOnlyName?: boolean;
  readOnlyPhone?: boolean;
  readOnlyMail?: boolean;
  useContactNameSelect?: boolean;
  useNestedModalPopper?: boolean;
  documentContacts?: IDocumentContactOption[];
  selectedContactIndex?: number;
}

const getContactNameInput = (state: IContactFieldState) => {
  const hasContacts =
    state.useContactNameSelect && (state.documentContacts?.length ?? 0) > 0;
  const selectedIndex =
    state.selectedContactIndex !== undefined && state.selectedContactIndex >= 0
      ? state.selectedContactIndex
      : 0;
  const selectedContactId = state.documentContacts?.[selectedIndex]?.id ?? "";

  if (hasContacts) {
    return {
      name: "documentContacts",
      label: "sales.quote.contactName",
      type: "select",
      placeholder: "prePayment.selectContact",
      required: false,
      parameterKey: "documentContacts",
      value: selectedContactId,
      options: (state.documentContacts || []).map((contact) => ({
        value: contact.id,
        text: (contact.contactName || "").trim(),
      })),
      isValid: true,
      readOnly: false,
      ...(state.useNestedModalPopper
        ? { autocompleteProps: getNestedModalAutocompleteProps() }
        : {}),
    };
  }

  return {
    name: "contactName",
    label: "sales.quote.contactName",
    type: "text",
    placeholder: "sales.quote.contactName",
    required: false,
    parameterKey: "contactName",
    value: state.contactName || "",
    options: [],
    isValid: true,
    readOnly: state.readOnlyName ?? true,
  };
};

const getSendToCustomerContactInputs = (state: IContactFieldState) => [
  getContactNameInput(state),
  {
    name: "contactPhone",
    label: "sales.quote.contactPhone",
    type: "phone",
    placeholder: "sales.quote.contactPhone",
    required: false,
    parameterKey: "contactPhone",
    value: state.contactPhone || "",
    options: [],
    isValid: true,
    readOnly: state.readOnlyPhone ?? false,
  },
  {
    name: "contactMail",
    label: "sales.quote.contactEmail",
    type: "text",
    placeholder: "sales.quote.contactEmail",
    required: false,
    parameterKey: "contactMail",
    value: state.contactMail || "",
    options: [],
    isValid: true,
    readOnly: state.readOnlyMail ?? false,
    regex: emailRegex,
  },
];

const getAdditionalEmailCcInput = (value: string) => ({
  name: "additionalEmailCc",
  label: "boardMissions.additionalEmailCc",
  type: "text",
  placeholder: "boardMissions.additionalEmailCc",
  required: false,
  parameterKey: "additionalEmailCc",
  value,
  options: [],
  isValid: true,
  readOnly: false,
  regex: emailRegex,
});

export { getSendToCustomerContactInputs, getAdditionalEmailCcInput };
